module.exports = __webpack_public_path__ + "img/honimunn.4d5eb3ca.png";